import { QuestionInput, QuestionType } from 'generated-graphql/types';
import { QuestionWithId } from 'pages/CampaignCreation/types';

const getPreferredAnswerText = (
  preferredAnswerText: string | null | undefined
) => {
  if (!preferredAnswerText) {
    return null;
  }

  if (preferredAnswerText.trim() === '') {
    return null;
  }
  return preferredAnswerText;
};

export const mapQuestionsPayloadV3 = (
  questionsWithId: QuestionWithId[]
): QuestionInput[] => {
  return questionsWithId.map((question, index) => {
    if (question.questionType === 'DOCUMENT') {
      return {
        questionType: QuestionType.Document,
        order: index,
        isMandatory: question.isMandatory,
        documentTypes: question.documentTypes,
        content: '',
        hasPreferredAnswer: null,
        preferredAnswerRequirements: null,
        preferredAnswerText: null,
        expectedAnswer: null
      };
    }

    if (question.isMandatory) {
      return {
        questionType: QuestionType.Text,
        order: index,
        isMandatory: true,
        content: question.content,
        expectedAnswer: question.expectedAnswer,
        documentTypes: undefined,
        hasPreferredAnswer: null,
        preferredAnswerRequirements: null,
        preferredAnswerText: null
      };
    }

    const preferredAnswerText = getPreferredAnswerText(
      question.preferredAnswerText
    );

    // Optional questions
    return {
      questionType: QuestionType.Text,
      order: index,
      isMandatory: false,
      content: question.content,
      preferredAnswerText,
      hasPreferredAnswer: preferredAnswerText ? true : null,
      expectedAnswer: null,
      documentTypes: undefined,
      preferredAnswerRequirements: null
    };
  });
};
